<template>
  <div id="alterations">
    <div class="header flex-between">
      <div class="header-text">
        <h1>数据角色定义</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          @click="searchsj"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="iconfont icon-chuangjian1"
          @click="createsj"
          >创建</el-button
        >
        <el-button
          v-if="jurisdiction.modify"
          icon="iconfont icon-xiugai1"
          @click="modifysj"
          >修改</el-button
        >
        <el-button
          v-if="jurisdiction.delete"
          icon="iconfont icon-a-shanchu11"
          @click="Deletesj"
          >删除</el-button
        >
        <el-button
          v-if="jurisdiction.look"
          icon="iconfont icon-chakan1"
          @click="Looksj"
          >查看</el-button
        >
      </div>
    </div>
    <!-- 首页查询card -->
    <el-card shadow="never">
      <div class="searchform">
        <el-form label-width="100px" :model="queryInfo" size="small">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="角色编号">
                <el-input
                  style="width: 50%"
                  v-model="queryInfo.roleCode"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="角色描述">
                <el-input
                  style="width: 50%"
                  v-model="queryInfo.roleName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建日期从">
                <el-date-picker
                  style="width: 50%"
                  v-model="queryInfo.datePicker"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <!-- 首页列表表格内容 -->
    <div>
      <el-card shadow="never" class="centercard">
        <el-table
          size="small"
          :height="isMore ? 'calc(100vh - 26.5rem)' : 'calc(100vh - 24rem)'"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            color: '#6C6839',
            'text-align': 'center',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="ActionrolesjList"
          tooltip-effect="dark"
          v-el-table-infinite-scroll="load"
          v-loading="loading"
          infinite-scroll-disabled="onLoading"
        >
          <!-- <el-table-column type="selection" width="45"> </el-table-column> -->
          <el-table-column width="40">
            <template slot-scope="scope">
              <el-radio
                :label="scope.$index"
                v-model="radio"
                @change="ActionrolesjRadioChange(scope.row)"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column>
          <el-table-column prop="roleCode" label="角色编号"> </el-table-column>
          <el-table-column prop="roleName" label="角色描述"> </el-table-column>
          <el-table-column prop="isValid" label="状态">
            <template slot-scope="scope">
              {{ scope.row.isValid === 0 ? "有效" : "无效" }}
            </template>
          </el-table-column>
          <el-table-column prop="createUserName" label="创建人">
          </el-table-column>
          <el-table-column prop="createTime" label="创建日期">
            <template slot-scope="scope">
              {{ scope.row.createTime | dateFormat }}
            </template>
          </el-table-column>
          <el-table-column prop="updateUserName" label="最后修改人">
          </el-table-column>
          <el-table-column prop="updateTime" label="最后修改日期">
            <template slot-scope="scope">
              <div v-if="scope.row.updateTime !== null">
                {{ scope.row.updateTime | dateFormat }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-alert
          v-if="isMore"
          title="没有更多啦!"
          type="warning"
          center
          show-icon
          :closable="false"
        >
        </el-alert>
      </el-card>
    </div>
    <!-- 创建弹窗 -->
    <div class="found">
      <el-dialog
        width="40%"
        top="5vh"
        title="角色定义—创建"
        :visible.sync="foundVisible"
        :close-on-click-modal="false"
        @close="createsjformClosed"
      >
        <div>
          <el-form
            size="mini"
            label-width="120px"
            :model="createsjForm"
            ref="createsjformRef"
            :rules="createsjFormRules"
          >
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="角色编号" prop="roleCode">
                  <el-input
                    style="width: 60%"
                    v-model="createsjForm.roleCode"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="角色描述" prop="roleName">
                  <el-input style="width: 60%" v-model="createsjForm.roleName">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="12">
                <el-form-item label="是否允许查看电话号码" prop="allowMobile">
                  <el-checkbox-group v-model="createsjForm.allowMobile">
                    <el-checkbox :true-label="1" :false-label="0"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="12"> </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="12">
                <el-form-item label="敏感信息原值导出到报表" prop="allowExportName">
                  <el-checkbox-group v-model="createsjForm.allowExportName">
                    <el-checkbox :true-label="1" :false-label="0"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="12"> </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="门店权限" prop="limitObjID">
                  <el-radio-group v-model="createsjForm.limitObjID">
                    <el-radio label="-1">所有</el-radio>
                    <el-radio label="-2">员工所属门店</el-radio>
                    <el-radio label="特定门店">特定门店</el-radio>
                    <el-button
                      :disabled="createsjForm.limitObjID != '特定门店'"
                      @click="outletVisible = true"
                      >选择门店</el-button
                    >
                  </el-radio-group>
                  <el-form-item :prop="isStoreSelectionMethod">
                    <textarea
                      style="width: 60%"
                      rows="8"
                      readonly
                      v-model="createsjForm.listOfSomeStoreslStr"
                    ></textarea>
                  </el-form-item>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="10">
                <el-form-item label="客户等级权限" prop="auth">
                  <el-radio-group v-model="createsjForm.auth">
                    <el-radio label="-1">所有等级</el-radio>
                    <el-radio label="-2">部分等级</el-radio>
                  </el-radio-group>
                  <el-checkbox-group
                    v-model="checkList"
                    style="display: flex; flex-direction: column"
                    v-if="createsjForm.auth == -2"
                  >
                    <el-checkbox
                      :label="item.levelID"
                      v-for="item in levelList"
                      :key="item.levelID"
                      >{{ item.levelName_cn }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="13">
                <el-form-item label="客户RMF标签权限" prop="auths">
                  <el-radio-group v-model="createsjForm.auths">
                    <el-radio label="-1">所有RMF标签</el-radio>
                    <el-radio label="-2">部分RMF标签</el-radio>
                  </el-radio-group>
                  <el-checkbox-group
                    v-model="checkRmfList"
                    style="display: flex; flex-direction: column"
                    v-if="createsjForm.auths == -2"
                  >
                    <el-checkbox
                      :label="item.sortIndex"
                      v-for="item in levelRmfList"
                      :key="item.sortIndex"
                      >{{ item.description_CN }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="10">
                <el-form-item label="业务分类" prop="bussKindAuths">
                  <el-radio-group v-model="createsjForm.bussKindAuths">
                    <el-radio label="-1">所有</el-radio>
                    <el-radio label="-2">部分</el-radio>
                  </el-radio-group>
                  <el-checkbox-group
                      v-model="checkBussBindList"
                      style="display: flex; flex-direction: column"
                      v-if="createsjForm.bussKindAuths == -2"
                  >
                    <el-checkbox
                        :label="item.busskind"
                        v-for="item in bussBindData"
                        :key="item.busskind"
                    >{{ item.bussnameCn }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="13">
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="createsjqd('createsjformRef')">保 存</el-button>
          <el-button @click="foundVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改弹窗 -->
    <div class="amend">
      <el-dialog
        width="40%"
        top="5vh"
        title="角色定义—修改"
        :visible.sync="amendVisible"
        :close-on-click-modal="false"
        @close="moifysjformClosed"
      >
        <div>
          <el-form
            size="mini"
            label-width="120px"
            :model="moifysjForm"
            ref="moifysjformRef"
            :rules="moifysjFormRules"
          >
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="角色编号" prop="roleCode">
                  <el-input
                    style="width: 60%"
                    v-model="moifysjForm.roleCode"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="角色描述" prop="roleName">
                  <el-input style="width: 60%" v-model="moifysjForm.roleName">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="12">
                <el-form-item label="是否允许查看电话号码" prop="allowMobile">
                  <el-checkbox-group v-model="moifysjForm.allowMobile">
                    <el-checkbox :true-label="1" :false-label="0"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="12"> </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="12">
                <el-form-item label="敏感信息原值导出到报表" prop="allowExportName">
                  <el-checkbox-group v-model="moifysjForm.allowExportName">
                    <el-checkbox :true-label="1" :false-label="0"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="12"> </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="门店权限" prop="limitObjID">
                  <el-radio-group v-model="moifysjForm.limitObjID">
                    <el-radio label="-1">所有</el-radio>
                    <el-radio label="-2">员工所属门店</el-radio>
                    <el-radio :label="null">特定门店</el-radio>
                    <el-button
                      :disabled="moifysjForm.limitObjID != null"
                      @click="outletVisible = true"
                      >选择门店</el-button
                    >
                  </el-radio-group>
                  <el-form-item :prop="isStoreSelectionMethodxg">
                    <textarea
                      style="width: 60%"
                      rows="8"
                      readonly
                      v-model="moifysjForm.listOfSomeStoreslStr"
                    ></textarea>
                  </el-form-item>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="10">
                <el-form-item label="客户等级权限" prop="auth">
                  <el-radio-group v-model="moifysjForm.auth">
                    <el-radio label="-1">所有等级</el-radio>
                    <el-radio label="-2">部分等级</el-radio>
                  </el-radio-group>
                  <el-checkbox-group
                    v-model="checkList"
                    style="display: flex; flex-direction: column"
                    v-if="moifysjForm.auth == -2"
                  >
                    <el-checkbox
                      :label="item.levelID"
                      v-for="item in levelList"
                      :key="item.levelID"
                      >{{ item.levelName_cn }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="13">
                <el-form-item label="客户RMF标签权限" prop="auths">
                  <el-radio-group v-model="moifysjForm.auths">
                    <el-radio label="-1">所有RMF标签</el-radio>
                    <el-radio label="-2">部分RMF标签</el-radio>
                  </el-radio-group>
                  <el-checkbox-group
                    v-model="checkRmfList"
                    style="display: flex; flex-direction: column"
                    v-if="moifysjForm.auths == -2"
                  >
                    <el-checkbox
                      :label="item.sortIndex"
                      v-for="item in levelRmfList"
                      :key="item.sortIndex"
                      >{{ item.description_CN }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="30">
              <el-col :span="10">
                <el-form-item label="业务分类" prop="bussKindAuths">
                  <el-radio-group v-model="moifysjForm.bussKindAuths">
                    <el-radio label="-1">所有</el-radio>
                    <el-radio label="-2">部分</el-radio>
                  </el-radio-group>
                  <el-checkbox-group
                      v-model="checkBussBindList"
                      style="display: flex; flex-direction: column"
                      v-if="moifysjForm.bussKindAuths == -2"
                  >
                    <el-checkbox
                        :label="item.busskind"
                        v-for="item in bussBindData"
                        :key="item.busskind"
                    >{{ item.bussnameCn }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="13">
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="moifysjqd('moifysjformRef')">保 存</el-button>
          <el-button @click="amendVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 查看弹窗 -->
    <div class="examine">
      <el-dialog
        width="40%"
        top="5vh"
        title="角色定义—查看"
        :visible.sync="examineVisible"
        :close-on-click-modal="false"
        @close="looksjformClosed"
      >
        <div>
          <el-form
            size="mini"
            label-width="120px"
            :model="looksjForm"
            ref="looksjformRef"
          >
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="角色编号" prop="roleCode">
                  <el-input
                    disabled
                    v-model="looksjForm.roleCode"
                    style="width: 60%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="角色描述" prop="roleName">
                  <el-input
                    disabled
                    v-model="looksjForm.roleName"
                    style="width: 60%"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="12">
                <el-form-item label="是否允许查看电话号码" prop="allowMobile">
                  <el-checkbox-group v-model="looksjForm.allowMobile">
                    <el-checkbox disabled></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="12"> </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="12">
                <el-form-item label="敏感信息原值导出到报表" prop="allowExportName">
                  <el-checkbox-group v-model="looksjForm.allowExportName">
                    <el-checkbox disabled></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="12"> </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="门店权限" prop="limitObjID">
                  <el-radio-group disabled v-model="looksjForm.limitObjID">
                    <el-radio label="-1">所有</el-radio>
                    <el-radio label="-2">员工所属门店</el-radio>
                    <el-radio :label="null">特定门店</el-radio>
                  </el-radio-group>
                  <el-form-item prop="cklistOfSomeStoreslStr">
                    <textarea
                      style="width: 60%"
                      rows="8"
                      readonly
                      v-model="cklistOfSomeStoreslStr"
                    ></textarea>
                  </el-form-item>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="10">
                <el-form-item label="客户等级权限" prop="auth">
                  <el-radio-group v-model="looksjForm.auth" disabled>
                    <el-radio label="-1">所有等级</el-radio>
                    <el-radio label="-2">部分等级</el-radio>
                  </el-radio-group>
                  <el-checkbox-group
                    disabled
                    v-model="checkList"
                    style="display: flex; flex-direction: column"
                    v-if="looksjForm.auth == -2"
                  >
                    <el-checkbox
                      :label="item.levelID"
                      v-for="item in levelList"
                      :key="item.levelID"
                      >{{ item.levelName_cn }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="13">
                <el-form-item label="客户RMF标签权限" prop="auths">
                  <el-radio-group v-model="looksjForm.auths" disabled>
                    <el-radio label="-1">所有RMF标签</el-radio>
                    <el-radio label="-2">部分RMF标签</el-radio>
                  </el-radio-group>
                  <el-checkbox-group
                    disabled
                    v-model="checkRmfList"
                    style="display: flex; flex-direction: column"
                    v-if="looksjForm.auths == -2"
                  >
                    <el-checkbox
                      :label="item.sortIndex"
                      v-for="item in levelRmfList"
                      :key="item.sortIndex"
                      >{{ item.description_CN }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="30">
              <el-col :span="10">
                <el-form-item label="业务分类" prop="bussKindAuths">
                  <el-radio-group v-model="looksjForm.bussKindAuths" disabled>
                    <el-radio label="-1">所有</el-radio>
                    <el-radio label="-2">部分</el-radio>
                  </el-radio-group>
                  <el-checkbox-group
                      disabled
                      v-model="checkBussBindList"
                      style="display: flex; flex-direction: column"
                      v-if="looksjForm.bussKindAuths == -2"
                  >
                    <el-checkbox
                        :label="item.busskind"
                        v-for="item in bussBindData"
                        :key="item.busskind"
                    >{{ item.bussnameCn }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="13">
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="24">
                <el-form-item label="创建人" prop="createUserName">
                  <div class="flex-start">
                    <el-input
                      disabled
                      style="width: 70%"
                      v-model="looksjForm.createUserName"
                    >
                    </el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="创建时间" prop="createTime">
                  <el-date-picker
                    style="width: 70%"
                    :disabled="true"
                    v-model="looksjForm.createTime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="最后修改人" prop="updateUserName">
                  <div class="flex-start">
                    <el-input
                      disabled
                      style="width: 70%"
                      v-model="looksjForm.updateUserName"
                    >
                    </el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="最后修改时间" prop="updateTime">
                  <el-date-picker
                    style="width: 70%"
                    :disabled="true"
                    v-model="looksjForm.updateTime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="examineVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 删除弹窗 -->
    <div class="delete">
      <el-dialog
        width="20%"
        title="删除数据角色定义表确认取消对话框"
        :visible.sync="deleteFormVisible"
        :close-on-click-modal="false"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要<span style="color: #ff0000">删除</span>数据角色定义表?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="deletesjqd">确 定</el-button>
          <el-button @click="deleteFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 选择门店弹窗 -->
    <div class="outlet">
      <el-dialog width="30%" :visible.sync="outletVisible" title="选择门店">
        <el-form size="mini" label-width="90px">
          <el-row
            :gutter="50"
            v-for="(item, index) in StoreSelectionList"
            :key="index"
          >
            <el-col :span="12" v-for="(myitem, myindex) in item" :key="myindex">
              <el-tree
                ref="tree"
                v-if="myitem != undefined"
                :data="[myitem]"
                show-checkbox
                node-key="id"
                highlight-current
                default-expand-all
                :props="defaultProps"
              >
              </el-tree>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ComButtomStore">确 定</el-button>
          <el-button @click="outletVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  SysrolesjpageApi,
  ShopqueryRegionApi,
  SysroleinsertDataDefindApi,
  SysroleupdateDataDefindApi,
  SysroledeletesjApi,
  SysrolequerysjApi,
  queryLSelectApi,
  queryRmfSelectApi, selectBussinDefineApi,
} from "@/api/user";
import { dateTimes } from "@/utils/auth";
export default {
  name: "alterations",
  data() {
    return {
      jurisdiction: {
        search: false,
        create: false,
        modify: false,
        delete: false,
        look: false,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      deleteFormVisible: false,
      examineVisible: false,
      amendVisible: false,
      outletVisible: false,
      foundVisible: false,
      radio: "",
      // // 首页搜索请求参数
      // searchsjlist: {
      //   roleType: "1",
      //   roleCode: "",
      //   roleName: "",
      //   createDateStart: "",
      //   createDateEnd: "",
      //   pageNo: 1,
      //   pageSize: 50,
      // },
      // 首页列表内容
      ActionrolesjList: [],
      // 首页列表radio选中的数据
      radioValuesjList: [],
      // 首页列表请求参数
      queryInfo: {
        roleCode: "",
        roleName: "",
        datePicker: "",
        createDateStart: "",
        createDateEnd: "",
        roleType: "1",
        pageNo: 1, //页码
        pageSize: 50, //页数据
        pages: 0, //页总数据
      },
      // 首页loading
      loading: false,
      // 创建弹窗列表
      createsjForm: {
        roleCode: "",
        roleName: "",
        allowMobile: "0",
        allowExportName: "0",
        limitObjID: "-1",
        listOfSomeStoresl: [],
        listOfSomeStoreslStr: "",
        auth: "-1",
        bussKindAuths: "-1",
        auths: "-1",
      },
      // 创建弹窗选择门店
      StoredataArray: [],
      StoreSelectLength: 0,
      // 选择门店数据
      StoreSelectionList: [],
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },
      // 创建弹窗表单验证
      createsjFormRules: {
        roleCode: [
          { required: true, message: "请输入角色编号", trigger: "blur" },
        ],
        roleName: [
          { required: true, message: "请输入角色描述", trigger: "blur" },
        ],
        listOfSomeStoreslStr: [
          {
            required: true,
            message: "请点击按钮选择部分门店",
            trigger: "change",
          },
        ],
      },
      // 修改弹窗表单验证
      moifysjFormRules: {
        roleCode: [
          { required: true, message: "请输入角色编号", trigger: "blur" },
        ],
        roleName: [
          { required: true, message: "请输入角色描述", trigger: "blur" },
        ],
        listOfSomeStoreslStr: [
          {
            required: true,
            message: "请点击按钮选择部分门店",
            trigger: "change",
          },
        ],
      },
      // 修改弹窗列表
      moifysjForm: {
        roleID: "",
        roleCode: "",
        roleName: "",
        allowMobile: "",
        allowExportName: "",
        limitObjID: "",
        shops: "",
        listOfSomeStoresl: [],
        listOfSomeStoreslStr: "",
        auth: "",
        auths: "",
        bussKindAuths: "",
      },
      moifysjFormcs: {
        roleID: "",
      },
      // 数据删除delete
      Deletesjid: {
        roleID: "",
      },
      // 首页radio选中获取数据
      // radioValuesjList: [],
      // 查看弹窗列表
      looksjForm: {},
      // 查看弹窗参数id
      looksjFormcs: {
        roleID: "",
      },
      cklistOfSomeStoresl: [],
      cklistOfSomeStoreslStr: "",
      levelList: [], //客户等级权限列表
      checkList: [], //选中的客户等级权限
      levelRmfList: [], //客户RMF标签权限
      checkRmfList: [], //客户RMF标签权限  选中的客户等级权限
      checkBussBindList: [], // 存放业务类型数据
      bussBindData: [], // 存放业务类型数据
    };
  },
  created() {
    queryLSelectApi().then((res) => (this.levelList = res.data));

    queryRmfSelectApi({ defineKindID: -1 }).then(
      (res) => (this.levelRmfList = res.data)
    );
    this.SysrolesjpageList();
    this.ShopqueryRegionList();
    this.bussinDefineList();
    let DataDefinition = JSON.parse(localStorage.getItem("DataDefinition"));
    for (let i = 0; i < DataDefinition.length; i++) {
      if (DataDefinition[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (DataDefinition[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }
      if (DataDefinition[i].menuName == "修改") {
        this.jurisdiction.modify = true;
        continue;
      }
      if (DataDefinition[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
      if (DataDefinition[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
    }
    // console.log(DataDefinition);
  },
  computed: {
    isMore() {
      //当起始页数等于总页数时停止加载
      return this.queryInfo.pageNo >= this.queryInfo.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
    isStoreSelectionMethod() {
      if (this.createsjForm.limitObjID == "特定门店") {
        return "listOfSomeStoreslStr";
      } else {
        return "Str";
      }
    },
    isStoreSelectionMethodxg() {
      if (this.moifysjForm.limitObjID == "特定门店") {
        return "listOfSomeStoreslStr";
      } else {
        return "Str";
      }
    },
  },
  methods: {
    // 首页radio选中获取数据
    ActionrolesjRadioChange(value) {
      this.radioValuesjList = value;
    },
    // 首页列表查询
    async searchsj() {
      this.radio = "";
      this.radioValuesjList = "";
      if (this.queryInfo.datePicker && this.queryInfo.datePicker.length > 0) {
        this.queryInfo.createDateStart = dateTimes(
          this.queryInfo.datePicker[0]
        );
        this.queryInfo.createDateEnd = dateTimes(this.queryInfo.datePicker[1]);
      } else {
        this.queryInfo.createDateStart = "";
        this.queryInfo.createDateEnd = "";
      }
      this.queryInfo.pageNo = 1;
      this.queryInfo.pageSize = 50;
      let data = {
        roleCode: this.queryInfo.roleCode,
        roleName: this.queryInfo.roleName,
        createDateStart: this.queryInfo.createDateStart,
        createDateEnd: this.queryInfo.createDateEnd,
        roleType: this.queryInfo.roleType,
        pageNo: this.queryInfo.pageNo, //页码
        pageSize: this.queryInfo.pageSize, //页数据
        pages: this.queryInfo.pages, //页总数据
      };
      await SysrolesjpageApi(data).then((res) => {
        if (res.success !== true) {
          this.$message.error("查询角色失败!");
          return;
        } else {
          this.$message.success("查询角色成功!");
          this.ActionrolesjList = res.data.list;
          this.queryInfo.pages = res.data.pages;
        }
      });
    },
    // 数据操作定义首页列表
    async SysrolesjpageList() {
      if (this.queryInfo.datePicker && this.queryInfo.datePicker.length > 0) {
        this.queryInfo.createDateStart = dateTimes(
          this.queryInfo.datePicker[0]
        );
        this.queryInfo.createDateEnd = dateTimes(this.queryInfo.datePicker[1]);
      } else {
        this.queryInfo.createDateStart = "";
        this.queryInfo.createDateEnd = "";
      }
      let data = {
        roleCode: this.queryInfo.roleCode,
        roleName: this.queryInfo.roleName,
        createDateStart: this.queryInfo.createDateStart,
        createDateEnd: this.queryInfo.createDateEnd,
        roleType: this.queryInfo.roleType,
        pageNo: this.queryInfo.pageNo, //页码
        pageSize: this.queryInfo.pageSize, //页数据
        pages: this.queryInfo.pages, //页总数据
      };
      await SysrolesjpageApi(data).then((res) => {
        if (this.queryInfo.pageNo == 1) this.ActionrolesjList = [];
        this.ActionrolesjList = this.ActionrolesjList.concat(res.data.list);
        this.queryInfo.pages = res.data.pages;
        this.loading = false;
      });
    },
    load() {
      // 滑倒底部时进行加载
      this.loading = true;
      setTimeout(() => {
        this.queryInfo.pageNo += 1;
        this.SysrolesjpageList();
      });
    },
    // 获取业务类型
    bussinDefineList() {
      selectBussinDefineApi().then((res) => {
        this.bussBindData = res.data;
      });
    },
    // 获取区域门店
    ShopqueryRegionList() {
      ShopqueryRegionApi({ state: 1 }).then((res) => {
        let arr1 = [],
          arr2 = [];
        if (res.success) {
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.shopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 选择门店
    ComButtomStore() {
      // 判断是否是创建弹窗
      if (this.createsjForm.limitObjID == "特定门店") {
        //获取已选择的门店数据
        this.createsjForm.listOfSomeStoresl = [];
        this.createsjForm.listOfSomeStoreslStr = "";
        for (let index = 0; index < this.StoreSelectLength; index++) {
          let item = this.$refs.tree[index].getCheckedNodes();
          if (item.length == this.StoredataArray[index].chlidren.length + 1) {
            this.createsjForm.listOfSomeStoresl.push(
              ...this.StoredataArray[index].chlidren
            );
          } else {
            this.createsjForm.listOfSomeStoresl.push(...item);
          }
        }
        this.createsjForm.listOfSomeStoresl.forEach((item) => {
          this.createsjForm.listOfSomeStoreslStr += `${item.lable}\n`;
        });
      } else {
        // 修改弹窗选择会员
        this.moifysjForm.listOfSomeStoresl = [];
        this.moifysjForm.listOfSomeStoreslStr = "";
        for (let index = 0; index < this.StoreSelectLength; index++) {
          let item = this.$refs.tree[index].getCheckedNodes();
          if (item.length == this.StoredataArray[index].chlidren.length + 1) {
            this.moifysjForm.listOfSomeStoresl.push(
              ...this.StoredataArray[index].chlidren
            );
          } else {
            this.moifysjForm.listOfSomeStoresl.push(...item);
          }
        }
        this.moifysjForm.listOfSomeStoresl.forEach((item) => {
          this.moifysjForm.listOfSomeStoreslStr += `${item.lable}\n`;
        });
      }
      this.outletVisible = false;
    },
    // 首页创建按钮事件
    createsj() {
      this.foundVisible = true;
      this.checkList = [];
      this.checkRmfList = [];
      this.checkBussBindList = [];
    },
    // 创建弹窗保存按钮事件
    createsjqd(createsjformRef) {
      //处理数据
      let limitObjID =
        this.createsjForm.limitObjID == "-1"
          ? "-1"
          : this.createsjForm.limitObjID == "-2"
          ? "-2"
          : undefined;
      let shopID = [];
      if (this.createsjForm.listOfSomeStoresl.length > 0) {
        //处理选择其他门店
        this.createsjForm.listOfSomeStoresl.forEach((item) => {
          shopID.push(item.id);
        });
      }
      // 发送请求参数
      let data = {
        roleType: "1",
        roleCode: this.createsjForm.roleCode, //角色编号
        roleName: this.createsjForm.roleName, //角色名字
        allowMobile: this.createsjForm.allowMobile, //是否允许电话
        allowExportName: this.createsjForm.allowExportName, //是否允许导出
        limitObjID: limitObjID, //门店权限
        shopID:
          this.createsjForm.limitObjID == "特定门店"
            ? shopID.join(",")
            : undefined, //特定门店 如果不是选中特定门店就是undefined
        levelID:
          this.createsjForm.auth === "-1" ? -1 : this.checkList.join(","),
        saleTagID:
          this.createsjForm.auths === "-1" ? -1 : this.checkRmfList.join(","),
        bussKind:
            this.createsjForm.bussKindAuths === "-1" ? -1 : this.checkBussBindList.join(","),
      };
      this.$refs[createsjformRef].validate(async (valid) => {
        if (!valid) return;
        SysroleinsertDataDefindApi(data).then((res) => {
          if (res.success !== true) {
            this.$message.error("创建数据角色定义失败!");
            return;
          }
          {
            this.$message.success("创建数据角色定义成功!");
            // 隐藏创建弹窗
            this.foundVisible = false;
            // 重新获取数据角色定义列表
            this.SysrolesjpageList();
            this.radio = "";
            this.radioValuesjList = "";
          }
        });
      });
    },
    // 监听创建弹窗关闭事件
    createsjformClosed() {
      this.$refs.createsjformRef.resetFields();
      // this.createsjForm.listOfSomeStoresl = [];
    },
    // 修改事件按钮
    modifysj() {
      if (this.radioValuesjList.length == 0) {
        this.$message.warning("请选择单挑数据,进行修改!");
      } else {
        this.moifycc();
        this.amendVisible = true;
      }
    },
    // 点击修改按钮将数据传给修改弹窗
    moifycc() {
      this.moifysjFormcs.roleID = this.radioValuesjList.roleID;
      this.checkList = [];
      this.checkRmfList = [];
      this.checkBussBindList = [];
      SysrolequerysjApi(this.moifysjFormcs).then((res) => {
        this.moifysjForm.roleID = res.data.roleID;
        this.moifysjForm.roleCode = res.data.roleCode;
        this.moifysjForm.roleName = res.data.roleName;
        this.moifysjForm.allowMobile = res.data.allowMobile;
        this.moifysjForm.allowExportName = res.data.allowExportName;
        this.moifysjForm.limitObjID = res.data.limitObjID;
        this.moifysjForm.shops = res.data.shops;
        if (res.data.levelID !== null) {
          if (res.data.levelID[0] === -1) this.moifysjForm.auth = "-1";
          else {
            this.moifysjForm.auth = "-2";
            this.checkList = res.data.levelID;
          }
        }
        if (res.data.saleTagID !== null) {
          if (res.data.saleTagID[0] === -1) this.moifysjForm.auths = "-1";
          else {
            this.moifysjForm.auths = "-2";
            this.checkRmfList = res.data.saleTagID;
          }
        }
        if (res.data.bussKindList !== null) {
          if (res.data.bussKindList[0] === -1) this.moifysjForm.bussKindAuths = "-1";
          else {
            this.moifysjForm.bussKindAuths = "-2";
            this.checkBussBindList = res.data.bussKindList;
          }
        }


        this.xgshops();
      });
    },
    xgshops() {
      if (this.moifysjForm.shops !== null) {
        this.moifysjForm.listOfSomeStoresl = [];
        this.moifysjForm.listOfSomeStoreslStr = "";
        for (var i in this.moifysjForm.shops) {
          this.moifysjForm.listOfSomeStoresl.push(this.moifysjForm.shops[i]);
        }
        this.moifysjForm.listOfSomeStoresl.forEach((item) => {
          this.moifysjForm.listOfSomeStoreslStr += `${item.shopName}\n`;
        });
        // this.moifysjForm.listOfSomeStoreslStr =
        //   this.moifysjForm.listOfSomeStoreslStr.substring(
        //     0,
        //     this.moifysjForm.listOfSomeStoreslStr.length - 1
        //   );
      }
    },
    // 修改弹窗确定事件
    moifysjqd(moifyformRef) {
      let limitObjID =
        this.moifysjForm.limitObjID == "-1"
          ? "-1"
          : this.moifysjForm.limitObjID == "-2"
          ? "-2"
          : undefined;
      let shopID = [];
      // listOfSomeStoresl不是空数组就遍历
      if (this.moifysjForm.listOfSomeStoresl != []) {
        //处理选择其他门店
        this.moifysjForm.listOfSomeStoresl.forEach((item) => {
          shopID.push(item.shopID);
        });
      }
      // 发送请求参数
      let data = {
        roleID: this.moifysjForm.roleID,
        roleType: "1",
        roleCode: this.moifysjForm.roleCode, //角色编号
        roleName: this.moifysjForm.roleName, //角色名字
        allowMobile: this.moifysjForm.allowMobile, //是否允许电话
        allowExportName: this.moifysjForm.allowExportName, //是否允许导出
        limitObjID: limitObjID, //门店权限
        shopID:
          // limitObjID选中为null 选中就加上分号 没有就undefined
          this.moifysjForm.limitObjID == null ? shopID.join(",") : undefined, //特定门店 如果不是选中特定门店就是undefined
        levelID: this.moifysjForm.auth === "-1" ? -1 : this.checkList.join(","),
        saleTagID:
          this.moifysjForm.auths === "-1" ? -1 : this.checkRmfList.join(","),
        bussKind:
          this.moifysjForm.bussKindAuths === "-1" ? -1 : this.checkBussBindList.join(","),
      };

      this.$refs[moifyformRef].validate(async (valid) => {
        if (!valid) return;
        SysroleupdateDataDefindApi(data).then((res) => {
          if (res.success !== true) {
            this.$message.error("修改数据角色定义失败!");
            return;
          }
          {
            this.$message.success("修改数据角色定义成功!");
            // 隐藏创建弹窗
            this.amendVisible = false;
            // 重新获取数据角色定义列表
            this.SysrolesjpageList();
            this.radio = "";
            this.radioValuesjList = "";
          }
        });
      });
    },
    // 监听修改弹窗关闭事件
    moifysjformClosed() {
      this.$refs.moifysjformRef.resetFields();
      this.moifysjForm.listOfSomeStoreslStr = "";
    },
    // 数据角色定义删除事件
    Deletesj() {
      if (this.radioValuesjList.length == 0) {
        this.$message.warning("请选择单条数据,进行删除!");
      } else {
        // 获得ID
        this.deleteczqq();
        // 打开确定删除弹窗
        this.deleteFormVisible = true;
      }
    },
    // 获得id事件
    deleteczqq() {
      this.Deletesjid.roleID = this.radioValuesjList.roleID;
    },
    // 确定删除弹窗确定事件
    async deletesjqd() {
      await SysroledeletesjApi(this.Deletesjid).then((res) => {
        if (res.success !== true) {
          this.$message.error("删除角色失败!");
          return;
        } else {
          this.$message.success("删除角色成功!");
          // 重新获取数据角色定义列表
          this.SysrolesjpageList();
          this.radio = "";
          this.radioValuesjList = "";
        }
      });
      // 关闭弹窗
      this.deleteFormVisible = false;
    },
    // 数据角色定义 --- 查看按钮事件
    Looksj() {
      if (this.radioValuesjList.length == 0) {
        this.$message.warning("请选择单条数据,进行查看!");
      } else {
        // 获取ID
        this.looksjid();
        // 发送请求查看记录
        SysrolequerysjApi(this.looksjFormcs).then((res) => {
          if (res.data.levelID !== null) {
            if (res.data.levelID[0] === -1) res.data.auth = "-1";
            else {
              res.data.auth = "-2";
              this.checkList = res.data.levelID;
            }
          }
          if (res.data.saleTagID !== null) {
            if (res.data.saleTagID[0] === -1) res.data.auths = "-1";
            else {
              res.data.auths = "-2";
              this.checkRmfList = res.data.saleTagID;
            }
          }

          if (res.data.bussKindList !== null) {
            if (res.data.bussKindList[0] === -1) res.data.bussKindAuths = "-1";
            else {
              res.data.bussKindAuths = "-2";
              this.checkBussBindList = res.data.bussKindList;
            }
          }
          this.looksjForm = res.data;
          if (res.success !== true) {
            this.$message.error("查看角色定义失败!");
            return;
          }
          this.$message.success("查看角色定义成功!");
          this.shops();
        });
        // 打开查看弹窗
        this.examineVisible = true;
      }
    },
    // 查看获取id事件
    looksjid() {
      this.looksjFormcs.roleID = this.radioValuesjList.roleID;
    },
    shops() {
      if (this.looksjForm.shops !== null) {
        this.cklistOfSomeStoresl = [];
        this.cklistOfSomeStoreslStr = "";
        for (var i in this.looksjForm.shops) {
          this.cklistOfSomeStoresl.push(this.looksjForm.shops[i]);
        }
        this.cklistOfSomeStoresl.forEach((item) => {
          this.cklistOfSomeStoreslStr += `${item.shopName}\n`;
        });
      }
    },
    // 监听查看弹框关闭事件
    looksjformClosed() {
      this.$refs.looksjformRef.resetFields();
      this.cklistOfSomeStoreslStr = "";
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
// #alterations {
//   height: 100%;
// }
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
.searchform {
  margin-top: 20px;
}
.centercard {
  margin-top: 10px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}
/deep/.el-col-13 {
  .el-form-item__label {
    width: 127px !important;
  }
  .el-form-item__content {
    margin-left: 127px !important;
  }
}
.el-table .warning-row {
  background: #fcfbf2;
}

.el-table .success-row {
  background: #ffffff;
}
::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }

  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  // 创建弹窗样式
  .found,
  .amend,
  .examine {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      .el-form-item__content {
        .el-radio-group {
          .el-radio {
            line-height: 2 !important;
          }
        }
      }
    }
    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
    // /deep .
  }
  //
  // /deep/.el-radio{
  //   line-height: 2 !important;
  // }
  // 选择门店弹框样式
  .outlet {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 20px 10px 20px 10px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
  }
  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
</style>
